<div class="container-fluid">
   <footer class="footer">
      <div class="row">
         <div class="col-md-12 footer-copyright text-center">
            <p class="mb-0">{{(setting$ | async )?.general?.copyright ?  (setting$ | async )?.general?.copyright : '© Pixelstrap'}}</p>
         </div>
      </div>
   </footer>
</div>